var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4998 10.0003V12.0003H4.49984V10.0003H3.1665V12.0003C3.1665 12.7337 3.7665 13.3337 4.49984 13.3337H12.4998C13.2332 13.3337 13.8332 12.7337 13.8332 12.0003V10.0003H12.4998ZM5.1665 6.00033L6.1065 6.94033L7.83317 5.22033V10.667H9.1665V5.22033L10.8932 6.94033L11.8332 6.00033L8.49984 2.66699L5.1665 6.00033Z",
    fill: "#FEFEFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.3bff79f05f1d67e7d4cfe08af2a9ba27.svg";
export { ForwardRef as ReactComponent };